import jexl from 'jexl'
import {has} from 'ramda'

import {
  FilterRuleType,
  OptionalFiltersContextType,
  OptionalFiltersContext as AccessControlContext
} from '../../types'

type OptionalFilters = string[]

declare let Sentry: typeof import('@sentry/browser')

// adds transform(action) function "map" that can be used in templates within FilterRuleType.
jexl.addTransform('map', (arr: string[], s: string) =>
  arr.map((x: string) => s.replace(/%s/g, x))
)

/**
 * Generates optional filters for search, used by accessControl
 * @param rules - criteria used to filter
 * @param context - optional filters
 */
export const buildOptionalFilters = (
  rules: FilterRuleType[],
  context: OptionalFiltersContextType | AccessControlContext
): OptionalFilters => {
  let filters: OptionalFilters = []

  rules.forEach(rule => {
    try {
      if (jexl.evalSync(rule.criteria, context)) {
        const optionalFilters: OptionalFilters = has('filters', rule)
          ? buildOptionalFilters(rule.filters, context)
          : rule.value.map((line: string) => jexl.evalSync(line, context))

        filters = [...filters, ...optionalFilters]
      }
    } catch (error) {
      if (typeof Sentry !== 'undefined') {
        Sentry.captureException(error)
      }
    }
  })

  return filters
}
